import { Action } from '@ngrx/store';

export enum cardActionType {
  SAVE_CARD = '[Card] save',
  GET_CARD_SERVER = '[Card] get',
  MODIFY_CARD = '[Card] modify',
  STATUS_CARD = '[Card] status',
  RESET_CARD='[Card] reset',
  UPLOAD_CARD='[Card] upload'
}
export class SaveCardAction implements Action {
  readonly type = cardActionType.SAVE_CARD;
  //add an optional payload
  constructor(public payload: any) {}
}
export class ModifyCardAction implements Action {
  readonly type = cardActionType.MODIFY_CARD;
  //add an optional payload
  constructor(public payload: any) {}
}
export class StatusCardAction implements Action {
  readonly type = cardActionType.STATUS_CARD;
  //add an optional payload
  constructor(public payload: any) {
    console.log(this.type);
  }
}
export class ResetCardAction implements Action {
  readonly type = cardActionType.RESET_CARD;
  //add an optional payload
  constructor(public payload: any) {}
}

export class UploadCardAction implements Action {
  readonly type = cardActionType.UPLOAD_CARD;
  //add an optional payload
  constructor(public payload: any) {}
}

export class GetCardServerAction implements Action {
  readonly type = cardActionType.GET_CARD_SERVER;
  //add an optional payload
  constructor(public payload: any) {}
}

export type CrudCardAction = SaveCardAction | ModifyCardAction | StatusCardAction | ResetCardAction | UploadCardAction | GetCardServerAction ;
